/**
 * Query string per API .NET: gli array diventano chiavi ripetute
 * (`idUtenti=153078&idUtenti=18727`), non `idUtenti[]=...`.
 */
export function serializeQueryParams(
  params: Record<string, unknown>
): string {
  const usp = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined || value === "") continue;

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item === null || item === undefined || item === "") continue;
        usp.append(key, String(item));
      }
    } else {
      usp.append(key, String(value));
    }
  }

  return usp.toString();
}
